const iconArrowLeft =
  '<svg viewBox="0 0 30.94 20.41" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-miterlimit="10"><path d="m30.94 10.2h-30" stroke-width=".64"/><path d="m10.41 20.2-10-9.99 10-10.01" stroke-width=".58"/></g></svg>';

export default iconArrowLeft;
